import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { fetchCustomFieldsAPI } from "../../../services/intent_prompt";
import { updateHistoryFields } from "../../../services/history_fields";
import { fetchMeUser } from "../../../services/user";

const History = () => {
    const [loading, setLoading] = useState(true);
    const [loadingSave, setLoadingSave] = useState(false);
    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            email_history_field: "",
            whatsapp_history_field: "",
            sms_history_field: "",
        },
    });


    const [customFields, setCustomFields] = useState(null);

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);


    useEffect(() => {
        const fetchAll = async () => {
            setLoading(true);
            try {
                const [customFieldsRes, userRes] = await Promise.all([
                    fetchCustomFieldsAPI(),
                    fetchMeUser(),
                ]);

                setCustomFields(customFieldsRes.data);

                const {
                    email_history_field,
                    whatsapp_history_field,
                    sms_history_field,
                } = userRes?.data;

                reset({
                    email_history_field: email_history_field || "",
                    whatsapp_history_field: whatsapp_history_field || "",
                    sms_history_field: sms_history_field || "",
                });
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, [reset]);


    const onSubmit = async (data) => {
        setLoadingSave(true);
        // call server api here
        try {
            const responseData = await updateHistoryFields(data);
            console.log({ responseData });
            if (responseData && responseData.status === "success") {
                setSuccess(responseData);
            }
        } catch (error) {
            setError(error);
        } finally {
            setLoadingSave(false);
        }

    };



    return (
        <div className="flex flex-row gap-4 px-10 pb-24">
            <div className=" flex items-center justify-center w-full">
                <div className=" w-full">
                    <form className="space-y-4 " onSubmit={handleSubmit(onSubmit)}>
                        <div className="flex justify-end">
                            <div className="flex flex-col mt-5">
                                <button
                                    type="submit"
                                    className={`group flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 
  ${loadingSave ? "bg-gray-400 cursor-not-allowed" : "hover:bg-blue-700 focus:ring-blue-500"}`}
                                >
                                    Save Changes
                                </button>
                                <div className="flex justify-center">
                                    {!!loadingSave && <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10 opacity-90  mt-4"></div>}
                                    {!!error && !loading && <div className="text-center text-red-500">{error?.message}</div>}
                                    {!loading && <div className="pt-2 text-green-600">{success?.message}</div>}
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-row w-full gap-4">
                            <div className="w-full">
                                {!loading ?
                                    <>
                                        <div className="">
                                            <label htmlFor="" className="">
                                                Email History
                                            </label>
                                            <select id="typedropdown" className="text-white  block w-full px-3 py-3  my-4 border  bg-gray-900  rounded-md  outline-none border-gray-800 focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500  sm:text-sm" {...register("email_history_field")}>
                                                <option value="" hidden>
                                                    Email Fields
                                                </option>
                                                {customFields?.map((field) => (
                                                    <option key={field.id} value={field.id}>
                                                        {field.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="">
                                            <label htmlFor="" className="">
                                                WhatsApp History
                                            </label>
                                            <select id="typedropdown" className="text-white  block w-full px-3 py-3  my-4 border  bg-gray-900  rounded-md  outline-none border-gray-800 focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500  sm:text-sm" {...register("whatsapp_history_field")}>
                                                <option value="" hidden>
                                                    WhatsApp Fields
                                                </option>
                                                {customFields?.map((field) => (
                                                    <option key={field.id} value={field.id}>
                                                        {field.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="">
                                            <label htmlFor="" className="">
                                                SMS History
                                            </label>
                                            <select id="typedropdown" className="text-white  block w-full px-3 py-3  my-4 border  bg-gray-900  rounded-md  outline-none border-gray-800 focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500  sm:text-sm" {...register("sms_history_field")}>
                                                <option value="" hidden>
                                                    SMS Fields
                                                </option>
                                                {customFields?.map((field) => (
                                                    <option key={field.id} value={field.id}>
                                                        {field.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </>
                                    :
                                    <div className="flex justify-center items-center min-h-48">
                                        <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10 opacity-90  mt-4"></div>
                                    </div>
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default History;
